import { TypographyBase } from "@/components/typography/Base";
import { cn } from "@/lib/utils";
import { AnimatePresence, motion } from "framer-motion";
import { Check, ChevronRight } from "lucide-react";
import { ReactNode, useState } from "react";

interface Props {
  title: string;
  icon: ReactNode;
  isCompleted: boolean;
  children?: ReactNode;
}

export function OnboardingStep({ title, icon, isCompleted, children }: Props) {
  const [isCollapsed, setIsCollapsed] = useState(isCompleted);

  return (
    <motion.div
      data-completed={isCompleted || null}
      layout="size"
      className="overflow-hidden group/step w-full px-6 rounded-md border items-center grid grid-cols-[40px_1fr_40px] transition-all data-[completed]:text-brand-gray-300 data-[completed]:dark:text-brand-gray-500 data-[completed]:border-brand-gray-100 data-[completed]:dark:border-transparent data-[completed]:dark:bg-brand-gray-900/35 data-[completed]:py-2 border-brand-primary/30 dark:border-brand-primary/20 bg-brand-gray-50 dark:bg-brand-gray-900 py-6"
    >
      {isCompleted ? <Check size={16} strokeWidth={3.5} /> : icon}
      <TypographyBase className="text-brand-primary font-bold group-data-[completed]/step:text-brand-gray-300 group-data-[completed]/step:dark:text-brand-gray-500 group-data-[completed]/step:font-normal">
        {title}
      </TypographyBase>

      {children && (
        <button
          className="h-full"
          onClick={() => setIsCollapsed((prev) => !prev)}
        >
          <ChevronRight
            size={18}
            className={cn(
              "justify-self-end text-brand-gray-400",
              !isCollapsed && "rotate-90"
            )}
          />
        </button>
      )}
      <AnimatePresence initial={false}>
        {children && !isCollapsed && (
          <motion.div
            className="dark:text-brand-gray-100 text-brand-gray-800 col-start-2 row-start-2 group-data-[completed]/step:text-brand-gray-300 group-data-[completed]/step:dark:text-brand-gray-500"
            initial={{ height: 0, marginTop: 0, opacity: 0 }}
            animate={{ height: "auto", marginTop: "12px", opacity: 1 }}
            exit={{ height: 0, marginTop: 0, opacity: 0 }}
            transition={{ ease: "circInOut", duration: 0.2 }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
